import React, { useEffect } from "react";
import { ConfigProvider, Layout, Spin } from "antd";
import Header from "./Header";

const { Content } = Layout;
const PageContainer = ({
  children,
  loading = false,
  classNames = "",
  headerProps,
  header = true,
  direction = "rtl",
  rootClassNames,
  pageContainerRef,
  ...props
}) => {
  useEffect(() => {
    if (props.className && rootClassNames) {
      props.className = props.className + " " + rootClassNames;
    } else if (rootClassNames) {
      props.className = rootClassNames;
    }

    // eslint-disable-next-line
  }, []);

  return (
    <div {...props} id="page-container" ref={pageContainerRef}>
      {header && <Header {...headerProps} />}
      <Content>
        <Spin spinning={loading}>
          <div className={"page-container-content " + classNames}>
            <ConfigProvider direction={direction}>
              {children && children}
            </ConfigProvider>
          </div>
        </Spin>
      </Content>
    </div>
  );
};

export default PageContainer;
